import React, { useState } from 'react';
import { badges } from '../utils/mockData';
import { AwardIcon, SearchIcon, UserIcon } from 'lucide-react';
const AwardBadgesPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBadge, setSelectedBadge] = useState<string | null>(null);
  const [showStudentModal, setShowStudentModal] = useState(false);
  // Mock student list
  const students = [{
    id: 'user1',
    name: '李明',
    email: 'liming@example.com',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
  }, {
    id: 'user2',
    name: '张伟',
    email: 'zhangwei@example.com',
    avatar: 'https://randomuser.me/api/portraits/men/42.jpg'
  }, {
    id: 'user3',
    name: '王芳',
    email: 'wangfang@example.com',
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg'
  }, {
    id: 'user4',
    name: '赵秀英',
    email: 'zhaoxy@example.com',
    avatar: 'https://randomuser.me/api/portraits/women/22.jpg'
  }];
  const handleAwardBadge = (badgeId: string) => {
    setSelectedBadge(badgeId);
    setShowStudentModal(true);
  };
  const handleConfirmAward = (studentId: string) => {
    // In a real app, you would send this to the server
    console.log('Awarding badge:', selectedBadge, 'to student:', studentId);
    // Close modal
    setShowStudentModal(false);
    setSelectedBadge(null);
    // Show success message
    alert('勋章发放成功！');
  };
  // Filter badges by search term
  const filteredBadges = badges.filter(badge => badge.name.toLowerCase().includes(searchTerm.toLowerCase()) || badge.description.toLowerCase().includes(searchTerm.toLowerCase()));
  // Filter students by search term
  const filteredStudents = students.filter(student => student.name.toLowerCase().includes(searchTerm.toLowerCase()) || student.email.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="max-w-5xl mx-auto" data-id="element-349">
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-350">发放勋章</h1>
      <div className="bg-white rounded-lg shadow p-4 mb-8" data-id="element-351">
        <div className="relative" data-id="element-352">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-353">
            <SearchIcon size={18} className="text-gray-400" data-id="element-354" />
          </div>
          <input type="text" placeholder="搜索勋章或学生..." className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-355" />
        </div>
      </div>
      <div className="mb-10" data-id="element-356">
        <h2 className="text-xl font-medium text-gray-800 mb-4 flex items-center" data-id="element-357">
          <AwardIcon size={20} className="text-blue-600 mr-2" data-id="element-358" />
          可发放的勋章
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-359">
          {filteredBadges.map(badge => <div key={badge.id} className="bg-white rounded-lg shadow p-6 text-center" data-id="element-360">
              <div className="text-4xl mb-4" data-id="element-361">{badge.icon}</div>
              <h3 className="font-medium text-gray-800 mb-2" data-id="element-362">{badge.name}</h3>
              <p className="text-gray-600 text-sm mb-4" data-id="element-363">{badge.description}</p>
              <div className="mb-4 inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs" data-id="element-364">
                {badge.pointsValue} 积分
              </div>
              <button onClick={() => handleAwardBadge(badge.id)} className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-365">
                发放给学生
              </button>
            </div>)}
        </div>
      </div>
      {/* Student Selection Modal */}
      {showStudentModal && selectedBadge && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-366">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full" data-id="element-367">
            <h2 className="text-xl font-medium text-gray-800 mb-4" data-id="element-368">
              选择要发放勋章的学生
            </h2>
            <div className="mb-4" data-id="element-369">
              <div className="relative" data-id="element-370">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-371">
                  <SearchIcon size={18} className="text-gray-400" data-id="element-372" />
                </div>
                <input type="text" placeholder="搜索学生..." className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-373" />
              </div>
            </div>
            <div className="max-h-60 overflow-y-auto mb-4" data-id="element-374">
              {filteredStudents.map(student => <div key={student.id} className="flex items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer" onClick={() => handleConfirmAward(student.id)} data-id="element-375">
                  {student.avatar ? <img src={student.avatar} alt={student.name} className="w-10 h-10 rounded-full mr-3" data-id="element-376" /> : <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center mr-3" data-id="element-377">
                      <UserIcon size={20} className="text-gray-500" data-id="element-378" />
                    </div>}
                  <div data-id="element-379">
                    <h3 className="font-medium text-gray-800" data-id="element-380">
                      {student.name}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-381">{student.email}</p>
                  </div>
                </div>)}
            </div>
            <div className="flex justify-end" data-id="element-382">
              <button onClick={() => setShowStudentModal(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-383">
                取消
              </button>
            </div>
          </div>
        </div>}
    </div>;
};
export default AwardBadgesPage;